
import { defineComponent, computed, ref } from 'vue'
export default defineComponent({
  name: 'LogUncheckRiskModal',
  props: {
    content: {
      type: Object,
      default: () => { return {} }
    },
    show: {
      type: Boolean,
      default: false
    },
  },
  emits: ['closeVirusScanModal'],
  setup (props, context) {
    const logCopyCntrTxt = ref<HTMLElement>()
    const innerContent = computed(() => props.content ? JSON.parse(props.content.virus_info) : null)
    const payload = computed(() => innerContent.value ? JSON.parse(innerContent.value.payload) : {})
    const visible = computed(() => props.show)
    return {
      visible,
      innerContent,
      payload,
      logCopyCntrTxt,
      closeModal () {
        context.emit('closeVirusScanModal')
      },
      copyTxt () {
        const selection = document.getSelection()
        selection.selectAllChildren(logCopyCntrTxt.value)
        document.execCommand('copy')
      }
    }
  }
})
